import React from 'react';
import { withStyles, Typography, Grid } from '@material-ui/core';
import { styles } from '../style';
import { connect } from 'react-redux';
import MyPATSelect from '../../../../../common/MyPATSelect';
import * as XLSX from 'xlsx';
import { contentManagementAction } from '../../../../reducers/contentMangementData';
import { bindActionCreators } from '@redux-saga/core/node_modules/redux';
import { AddScheduledTestState, AddScheduledTestProps } from './helpers/AddScheduledTestTypes';
import { distributeTests, getNewTestList, addSuggestedTests } from './helpers';
import { EXISTING } from '../Constants/Constants';
import { MyPATDialog } from '../../../../../common';
import contentManagementService from '../../../../service/courseManagementServices';
import { AddNewTest, BulkTestAdder } from './';
import { CourseTypes } from '../../../../types/enums/CourseTypes';
import courseManagementServices from '../../../../service/courseManagementServices';
import { Template } from '../../../../types/interfaces/CourseBasicDetails';
import * as courseManagementActions from "../../../../actions/courseManagementActions";
import { showMsg as showAlert } from "../../../../../course/actions/loaderAlert";
import _ from 'lodash';
import { checkForDuplicateTests, checkForDuplicateTestsWithinSheet } from '../helpers/checkAddedTest';

class AddScheduledTest extends React.PureComponent<AddScheduledTestProps, AddScheduledTestState> {
  constructor(props: AddScheduledTestProps) {
    super(props);

    this.state = {
      activeGoals: [],
      testType: '',
      testTypeError: '',
      fileData: '',
      // downloadUrl: '',
      importedTests: [],
      goalId: '',
      show: false,
      newTests: [],
      index: 0,
      name: '',
      startDate: new Date(),
      startTime: new Date(),
      endDate: new Date(),
      endTime: new Date(),
      maxAttempts: '',
      syllabus: '',
      duration: 180,
      error: '',
      dateError: '',
      scheduleTestSuggestions: [],
      type: 'full',
      courseId: '',
      packages: [],
      selectedPackage: {},
    };
  }


  showAlerts = (msg: string) => {
    if (msg === 'Test Added') {
      this.props.showAlert('Test Added', 'success');
      return;
    }
    const messages = ['Test date does not lie in any week', 'Test already exists in the course', 'Test date does not lie in any phase']
    if (messages.includes(msg)) {
      this.props.showAlert(msg, 'error')
    }
  }
  setActiveGoals = (goalData: any) => {
    this.setState({
      activeGoals: goalData,
    });
  };

  handleClose = () => {
    this.setState({
      testType: '',
      testTypeError: '',
      fileData: '',
      // downloadUrl: '',
      importedTests: [],
      goalId: '',
      show: false,
      newTests: [],
      index: 0,
      name: '',
      startDate: new Date(),
      endDate: new Date(),
      maxAttempts: '',
      syllabus: '',
      duration: 180,
      error: '',
      dateError: '',
      scheduleTestSuggestions: [],
      selectedPackage: {},
    });
    this.props.onClose();
  };

  componentDidUpdate(prevProps: AddScheduledTestProps) {
    if (
      this.props.totalGoalsForComboCourse.length &&
      prevProps.totalGoalsForComboCourse !== this.props.totalGoalsForComboCourse
    ) {
      this.setActiveGoals(this.props.totalGoalsForComboCourse);
    }
    if(prevProps.existingScheduledTests!==this.props.existingScheduledTests){
      this.modifyScheduleTest(this.props.existingScheduledTests);
    }
  }

  componentDidMount() {
    this.setActiveGoals(this.props.totalGoalsForComboCourse);
  }

  renderSelectGoalOptions = () => {
    const { classes } = this.props;
    return (
      <>
        <Typography className={classes.inputLable}>
          Select a goal
          <span className={classes.colorRed}>*</span>
        </Typography>
        <MyPATSelect fullWidthControl onChange={this.handleGoalSelect}>
          <option value={''}>{'Select Goal'}</option>
          {this.state.activeGoals.map((goal: any) => (
            <option key={goal.courseName} value={goal.courseId}>
              {goal.courseName}
            </option>
          ))}
        </MyPATSelect>
      </>
    );
  };

  readExcelFile = (file: any) => {
    const promise = new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsArrayBuffer(file);

      fileReader.onload = (event: any) => {
        const bufferArray = event.target.result;
        const workbook = XLSX.read(bufferArray, { type: 'buffer' });
        const worksheetName = workbook.SheetNames[0];
        var worksheet = workbook.Sheets[worksheetName];
        const fileData = XLSX.utils.sheet_to_json(worksheet);
        resolve(fileData);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
    promise
      .then((fileData: any) => {
        fileData = fileData.filter((test: any) => {
          for(const [field, value] of Object.entries(test)) {
            if(typeof value !== 'string' || value.trim().length > 0) {
              return true;
            }
          }
          return false;
        })
        
        this.setState({ fileData });
      })
      .catch((error: any) => {
      });
  };

  handleFileInput = (file: any) => {
    // let file = event.target.files[0];
    if (file.name.endsWith('xlsx') || file.name.endsWith('xls')) {
      this.readExcelFile(file);
      this.setState({ testTypeError: '' });
    } else {
      this.setState({ testTypeError: 'Please upload an excel file.' });
    }
  };

  handleUpload = async () => {
    const { testType, fileData, goalId } = this.state;
    
    const { packageId, treeData: coursePlan } = this.props;
   
    if (testType && fileData && goalId) {
      
      const newTests = getNewTestList({ fileData, testType, goalId });

      const { duplicateExists, duplicateTestData } = checkForDuplicateTests(coursePlan.phases , newTests)
      const isAnyTestInSheetDuplicate = checkForDuplicateTestsWithinSheet(fileData);

      if (newTests.length && !duplicateExists && !isAnyTestInSheetDuplicate) {
       
        
        this.setState({
          newTests,
          name: newTests[this.state.index].name || '',
          startDate: newTests[this.state.index].startDate || new Date(),
          endDate: newTests[this.state.index].endDate || 'NA',
          maxAttempts: newTests[this.state.index].maxAttempts || '',
          syllabus: newTests[this.state.index].syllabus || '',
          duration: newTests[this.state.index].duration || 180,
          // show: true,
        }, async () => {
          const { packageByIdData: packageData } = this.props;
        
        // const downloadURL = await distributeTests(
          await distributeTests(
          { fileData, testType, goalId, showMessage: (msg:string)=>this.showAlerts(msg), packageId },
          this.props.treeData,
          this.props.setTreeData,
          packageData
          // this.showAlerts
          );
      
          this.handleClose();
        });

        
      } else {
        const { packageByIdData: packageData } = this.props;
        
        // const downloadURL = await distributeTests(
        if(!duplicateExists && !isAnyTestInSheetDuplicate) {
          await distributeTests(
            { fileData, testType, goalId, showMessage: (msg:string)=>this.showAlerts(msg), packageId },
            this.props.treeData,
            this.props.setTreeData,
            packageData
            // this.showAlerts
          );
        }

        if(isAnyTestInSheetDuplicate)
        {
          this.props.showAlert('Duplicate test in sheet.', 'error')
        }

        if(duplicateExists){
          this.props.showAlert('Test already exists in the course', 'error')
        }
      
        this.handleClose();
      }
    } else {
      
      this.setState({ testTypeError: 'Select goal before uploading the file.' });
    }
    // debugger;
  };

  toggleNewTest = () => {
    this.setState({ show: !this.state.show });
  };

  handleScheduledTestSelection = (selections: any) => {
    
    if (selections.length) {
      this.setState({ importedTests: selections });
    }
  };

  getScheduledTests = async (courseId: string) => {
    const param = {
      itemType: 'scheduledTests',
      id: courseId,
    };
    const response = await contentManagementService.fetchScheduleTests(param);
    const existingScheduledTests = response;
    this.modifyScheduleTest(existingScheduledTests);
  };

  modifyScheduleTest = (existingScheduledTests: any) => {
    const scheduledTests: any = [];
    existingScheduledTests &&
      existingScheduledTests.forEach((scheduledTest: any) => {
        let test = {
          label: scheduledTest.name || scheduledTest.displayName,
          value: { ...scheduledTest },
          id: scheduledTest._id || scheduledTest.testId,
        };
        scheduledTests.push(test);
      });
    this.setState({ scheduleTestSuggestions: [...scheduledTests] });
  };

  handleGoalSelect = (event: any) => {
    if (event.target.value) {
      this.setState({ goalId: event.target.value, selectedPackage:{}, importedTests:[] });
      if (this.state.testType === EXISTING) {
        this.setPackages(event.target.value);
        this.getScheduledTests(event.target.value);
      }
    } else {
      if (this.state.testType === EXISTING) {
      this.setState({ goalId: event.target.value, scheduleTestSuggestions: [], selectedPackage:{}, importedTests:[] }); 
      }
    }
  };

  setRadioSelection = (testType: string) => {
    this.setState({ testType, testTypeError: '' });
  };

  handleAddSuggestionTests = () => {
    const { importedTests } = this.state;
    const { packageByIdData: packageData} = this.props;

    let testArray: any = [];
    if (importedTests.length) {
      importedTests.forEach((test: any) => {
        testArray.push(test.value);
      });
      addSuggestedTests(testArray, this.props.treeData, this.props.setTreeData, {showMessage: (msg:string)=>this.showAlerts(msg)}, packageData);
    }
    
    this.handleClose();
  };

   


  setPackages = (goalId:string) => {
    if (goalId) {
      let queryParams: any = {};
      queryParams.type = CourseTypes.combo;
      queryParams.goals = goalId;
      queryParams.pagination = false;
      courseManagementServices.getPackageTemplates(queryParams).then((response: any) => {
        const { responseObject = {} } = response;
        const packages = responseObject.packages || [];
        this.setState({ packages: packages });
      });
    }
  };

  handlePackageSelect = (selectedPackage: Template) => {
    if(selectedPackage)
    {
      this.setState({
        importedTests:[],
      selectedPackage
    }, ()=>{
      this.props.fetchExistingScheduledTests(selectedPackage.coursePlanId._id);
      })
    }
  };

  renderBulkTestAdder = () => {
    const { 
      // downloadUrl, 
      testType, scheduleTestSuggestions, testTypeError, packages, selectedPackage, importedTests } = this.state;
    const { classes } = this.props;
    // debugger;
    return (
      <BulkTestAdder
        // downloadUrl={downloadUrl}
        classes={classes}
        setRadioSelection={this.setRadioSelection}
        testTypeError={testTypeError}
        testType={testType}
        renderSelectGoalOptions={this.renderSelectGoalOptions}
        // scheduleTestSuggestions={scheduleTestSuggestions}
        scheduleTestSuggestions={scheduleTestSuggestions}
        selectedPackage={selectedPackage}
        handleUpload={this.handleUpload}
        handleScheduledTestSelection={this.handleScheduledTestSelection}
        handleAddSuggestionTests={this.handleAddSuggestionTests}
        handleFileInput={this.handleFileInput}
        hasScheduledTestSuggestions={Boolean(scheduleTestSuggestions.length)}
        hasSelectedGoal={Boolean(this.state.goalId)}
        hasSelectedTests={Boolean(this.state.importedTests.length)}
        packages={packages}
        handlePackageSelect={this.handlePackageSelect}
        importedTests={importedTests}
      />
    );
  };

  handleFormChange = (event: any) => {
    const { name, value } = event.target;
    if (name === 'maxAttempts' || name === 'duration') {
      if (isNaN(value)) this.setState({ ...this.state, [name]: '' });
      else this.setState({ ...this.state, [name]: parseInt(value) });
    } else if (name === 'startDate' || name === 'endDate') {
      const date = new Date(value);
      this.setState({ ...this.state, [name]: date });
    } else {
      this.setState({ ...this.state, [name]: value });
    }
  };

  setNewTestValues = (newTests: any[], index: number) => {
    const { name, syllabus, maxAttempts, duration, startDate, endDate } = this.state;

    newTests[index].paperDetail = {
      syllabus: '',
      id: '',
      name: '',
      type: '',
      testType: '',
      duration: '',
      status: '',
      codeName: '',
      displayName: '',
      scheduleID: '',
      scheduleDate: '',
      startTime: '',
      scheduleEndDate: '',
      endTime: '',
      maxAttempt: '',
      blockRevisionTime: '',
      // _id:''
    };
    newTests[index].name = name;
    newTests[index].syllabus = syllabus;
    newTests[index].maxAttempts = maxAttempts;
    newTests[index].duration = duration;
    newTests[index].startDate = startDate;
    newTests[index].courseId = this.state.goalId;
    if (endDate !== 'NA') {
      newTests[index].endDate = endDate;
    }
    newTests[index].type = 'full';
  };

  prepareNewTest = (newTests: any[], index: number) => {
    this.setState({
      error: '',
      index: index + 1,
      name: newTests[index + 1].name || '',
      startDate: newTests[index + 1].startDate || new Date(),
      endDate: newTests[index + 1].endDate || 'NA',
      maxAttempts: newTests[index + 1].maxAttempts || '',
      syllabus: newTests[index + 1].syllabus || '',
      duration: newTests[index + 1].duration || 180,
    });
  };

  handleSubmit = async () => {
    const { name, syllabus, maxAttempts, duration, startDate } = this.state;
    const { packageId, packageByIdData: packageData } = this.props;
    const hasError = !name || !syllabus || !maxAttempts || !duration || !startDate;
    if (hasError) {
      this.setState({ error: 'All fields are required.' });
      return;
    }
    const { newTests, index } = this.state;
    this.setNewTestValues(newTests, index);
    if (index < newTests.length - 1) {
      this.prepareNewTest(newTests, index);
      return;
    }
    this.setState({ error: '', show: false });
    const { fileData, testType, goalId } = this.state;
    const { treeData, setTreeData } = this.props;
    // const downloadURL = await distributeTests({ fileData, 
    // testType, goalId }, treeData, setTreeData);
    await distributeTests({ fileData, testType, goalId, showMessage: (msg:string)=>this.showAlerts(msg), packageId  }, treeData, setTreeData, packageData);
    this.handleClose();
    
    // this.setState({ downloadUrl: downloadURL || 'Error occured!' });
  };

  isDateRangeValid = () => {
    const { startDate, endDate } = this.state;
    if (!endDate) {
      return true;
    }
    if (typeof endDate === 'string') {
      return true;
    }

    if (endDate instanceof Date && new Date(startDate).getTime() >= new Date(endDate).getTime()) {
      this.setState((prevState) => ({ ...prevState, dateError: 'Invalid Date Range' }));
      return false;
    }
    this.setState((prevState) => ({ ...prevState, dateError: '' }));
    return true;
  };

  handleStartDate = (date: Date | null) => {
    if (date) {
      const { startTime } = this.state;
      const newDateString = new Date(date.toDateString() + startTime.toString().slice(15));
      this.setState((prevState) => ({ ...prevState, startDate: newDateString, startTime: newDateString }));
    }
  };

  handleStartTime = (time: any) => {
    const { startDate } = this.state;
    const newDateString = new Date(startDate.toDateString() + time.toString().slice(15));
    this.setState((prevState) => ({ ...prevState, startDate: newDateString, startTime: newDateString }));
  };

  handleEndDate = (date: Date | null) => {
    if (date && this.state.endTime) {
      const { endTime } = this.state;
      const newDateString = new Date(date.toDateString() + endTime.toString().slice(15));
      this.setState((prevState) => ({ ...prevState, endDate: newDateString, endTime: newDateString }));
    }
  };

  handleEndTime = (time: any) => {
    const { endDate } = this.state;
    if (endDate instanceof Date) {
      const newDateString = new Date(endDate.toDateString() + time.toString().slice(15));
      this.setState((prevState) => ({ ...prevState, endDate: newDateString, endTime: newDateString }));
    }
  };

  renderAddNewTest = () => {
    const { classes, treeData } = this.props;
    const {
      error,
      name,
      syllabus,
      startDate,
      endDate,
      maxAttempts,
      duration,
      dateError,
      startTime,
      endTime,
    } = this.state;
    return (
      <AddNewTest
        handleFormChange={this.handleFormChange}
        handleStartDate={this.handleStartDate}
        handleEndDate={this.handleEndDate}
        handleSubmit={this.handleSubmit}
        handleStartTime={this.handleStartTime}
        handleEndTime={this.handleEndTime}
        isDateRangeValid={this.isDateRangeValid}
        maxDate={new Date(treeData.endDate)}
        minDate={new Date(treeData.startDate)}
        test={{ name, error, maxAttempts, duration, syllabus, startDate, endDate, dateError, startTime, endTime }}
        classes={classes}
      />
    );
  };

  render() {
    const { show } = this.state;
    const { open, classes } = this.props;
    
    return (
      <div>
        <MyPATDialog
          dialogOpen={open}
          dialogHasActions={true}
          dialogHeading={ <>
              <span className={classes.requestDialogTitle}>
              Add Scheduled Tests
              </span>
            </>}
          isAlignCenter={true}
          customButtonVariant='withoutBorderCloseIcon'
          onDialogClose={this.handleClose}
          isCustomBackground={false}
          isborderDialogAction={true}
          otherDialogProps={{
            fullWidth: false,
            maxWidth: 'sm',
          }}
        >
          <Grid container justify='center'>
            {show ? this.renderAddNewTest() : this.renderBulkTestAdder()}
          </Grid>
        </MyPATDialog>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    goals: state.courseMangementData.courseManagementReducer.activeGoals,
    treeData: state.courseMangementData.contentManagementData.treeData,
    totalGoalsForComboCourse: state.courseMangementData.contentManagementData.totalGoalsForComboCourse,
    existingScheduledTests: state.courseMangementData.courseManagementReducer.existingScheduledTests,
    packageByIdData: _.get(state, 'courseMangementData.contentManagementData.packageByIdData', {}),
  };
};
const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      fetchExistingScheduledTests: courseManagementActions.fetchExistingScheduledTests,
      setTreeData: contentManagementAction.setTreeData,
      showAlert
    },
    dispatch
  );
// @ts-ignore
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  // @ts-ignore
  withStyles(styles)(AddScheduledTest)
);
